import { Box, Typography } from "@mui/material";
import { ReactNode, useContext, useState } from "react";
import { LanguageContext } from "../../../globals/LanguageContext";
import { StyledQuoteCard } from "./quoteCard.styled";
import { ArrowsOut, Plus } from "@phosphor-icons/react";
import { AddQuoteForm } from "../../form/AddQuoteForm";

type QuoteCardProps = {
  onClick: (component: ReactNode) => void;
};

export const QuoteCard = ({ onClick }: QuoteCardProps) => {
  const [opened, setopened] = useState<boolean>(false);
  const { dictionary } = useContext(LanguageContext);

  return (
    <StyledQuoteCard opened={opened}>
      <Box className="head">
        <Typography variant="h3">
          {dictionary.pages.projects.project.quote.title}
        </Typography>
        <Box>
          <Plus
            size={32}
            weight="bold"
            className="button"
            onClick={() => onClick(<AddQuoteForm />)}
          />{" "}
          <ArrowsOut
            size={32}
            weight="bold"
            className="button"
            onClick={() => setopened(!opened)}
          />
        </Box>
      </Box>
    </StyledQuoteCard>
  );
};
